import './master-service-agreement-document.css';

export const formatReactStringToHTMLString = (reactString: string = '') => {
  return reactString
    .replace(/\{' '\}/g, ' ') // Replace JSX spaces to HTML spaces
    .replace(/{'\\n'}/g, '\n') // Replace JSX newlines to HTML newlines
    .replace(/className/g, 'class') // Replace JSX classNames to HTML classes
    .trim();
};

/* Note: This document will be stored on BE as a string, we store original document for testing.
  =============================================================================================
  Formatting: since we're storing JSX string - we need to replace all JSX-related syntax to native HTML syntax (see "formatReactStringToHTMLString")
  Testing: if you want to render it - you need to insert it via "dangerouslySetInnerHTML".
*/
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const DO_NOT_USE_DIRECTLY_AGREEMENT_DOCUMENT_TEXT = `
    <div className='agreement-wrapper'>
      <div className='agreement-heading'>
        <div>
          CrediVault Corp., a Delaware corporation with offices located at 21550 Biscayne Blvd., Ste. 400, Aventura, FL
          33180 (the “<b>Company</b>”), is in the business of providing access to WireVault, a secure blockchain-enabled
          software platform providing an immutable ledger (registry) of digital wire data and information.
        </div>
        <div>
          As the Customer, you desire to access the System, and the Company desires to provide Customer access to the
          System, subject to the terms and conditions of this Agreement.
        </div>
        <div>
          The Company and Customer may be referred to herein collectively as the “<b>Parties</b>” or individually as a “
          <b>Party</b>”.
        </div>
        <div>
          In the event of any inconsistency between the Master Service Agreement, the CrediVault Terms and Conditions,
          or any other CrediVault policy, the terms of the Master Service Agreement shall govern to the extent of that
          inconsistency (a copy of CrediVault’s Terms and Conditions is found at{' '}
          <a className='agreement-link' href='https://wirevault.co/terms' target='_blank'>
            https://wirevault.co/terms
          </a>
          ).
        </div>
        <div>
          <div className='agreement-label'>Agreement:</div>
          <div>Company and Customer hereby enter into this Agreement for Services as of Checkout Date.</div>
        </div>
      </div>

      <div>
        <div className='agreement-section-header'>1. Provision of Access.</div>
        <div className='agreement-section-content'>
          <div>
            Subject to and conditioned upon Customer’s payment of Fees and compliance with all other policies and terms
            and conditions of this Agreement, the Company hereby grants Customer a non-exclusive, non transferable,
            non-sublicensable right to access and use the System during the Term in accordance with the terms and
            conditions herein.
          </div>
          <div>
            <b>1.1</b> Company shall offer support services in connection with Customer’s access to and use of the
            System. Company reserves the right to modify the System and/or the support services from time to time at the
            sole discretion of the Company. Any such support services available to the Customer, or any modification of
            previously offered support services shall be communicated to the Customer.
          </div>
        </div>
      </div>

      <div>
        <div className='agreement-section-header'>2. Customer Responsibilities and Covenants.</div>
        <div>
          Customer is responsible and liable for all misuses of the System resulting from access provided by Customer,
          directly or indirectly, whether such access or use is permitted by or in violation of this Agreement and/or
          CrediVault Terms and Conditions.
        </div>
      </div>

      <div>
        <div className='agreement-section-header'>3. Fees / Payments.</div>
        <div>Customer shall pay the Company fees at Checkout. Fees are exclusive of taxes.</div>
      </div>

      <div>
        <div className='agreement-section-header'>4. Confidential Information.</div>
        <div>
          From time to time during the Term, either Party may disclose or make available to the other Party information
          about its business affairs, products, confidential intellectual property, trade secrets, third-party
          confidential information, and other sensitive or proprietary information, whether orally or in written,
          electronic, or other form or media, whether or not marked, designated or otherwise identified as
          “confidential” (collectively, “Confidential Information”). Confidential Information does not include
          information that, at the time of disclosure is: (a) in the public domain; (b) known to the receiving Party at
          the time of disclosure; (c) rightfully obtained by the receiving Party on a non-confidential basis from a
          third party; or (d) independently developed by the receiving Party. The receiving Party shall not disclose the
          disclosing Party’s Confidential Information to any person or entity, except to the receiving Party’s employees
          or agents who have a need to know the Confidential Information for the receiving Party to exercise its rights
          or perform its obligations hereunder. Notwithstanding the foregoing, each Party may disclose Confidential
          Information to the limited extent required (i) in order to comply with the order of a court or other
          governmental body, or as otherwise necessary to comply with applicable law, provided that the Party making the
          disclosure pursuant to the order shall first, to the extent permitted by applicable law, have given written
          notice to the other Party and allow the disclosing Party a reasonable opportunity to obtain a protective
          order; or (ii) to establish a Party’s rights under this Agreement, including to make required court filings.
          On the expiration or termination of the Agreement, the receiving Party shall promptly return to the disclosing
          Party all copies (other than immutable copies recorded to the System’s blockchain ledger), whether in written,
          electronic, or other form or media, of the disclosing Party’s Confidential Information, or destroy all such
          copies and certify in writing to the disclosing Party that such Confidential Information has been destroyed.
          Each Party’s obligations of non-disclosure with regard to Confidential Information are effective as of the
          Effective Date and will expire five years from the date first disclosed to the receiving Party; provided,
          however, with respect to any Confidential Information retained by a receiving Party or that constitutes a
          trade secret (as determined under applicable law), such obligations of non-disclosure will survive the
          termination or expiration of this Agreement for as long as such Confidential Information remains with the
          receiving Party or subject to trade secret protection under applicable law.
        </div>
      </div>

      <div>
        <div className='agreement-section-header'>5. Intellectual Property.</div>
        <div>
          Customer acknowledges that, as between Customer and the Company, the Company owns all right, title, and
          interest, including all intellectual property rights, in and to the Company IP and no such rights are
          transferred on the basis of this Agreement, and with respect to third-party products, the applicable
          third-party providers own all right, title, and interest, including all intellectual property rights, in and
          to the third-party products.{' '}
        </div>
      </div>

      <div>
        <div className='agreement-section-header'>6. Limitations of Liability.</div>
        <div>
          EXCEPT FOR THE DEFENSE AND INDEMNITY OBLIGATIONS DETAILED IN SECTION 7, IN NO EVENT SHALL EITHER PARTY BE
          LIABLE TO THE OTHER PARTY FOR ANY INCIDENTAL, CONSEQUENTIAL, INDIRECT, OR PUNITIVE DAMAGES (INCLUDING BUT NOT
          LIMITED TO LOST PROFITS), REGARDLESS OF WHETHER SUCH LIABILITY IS BASED ON BREACH OF CONTRACT, TORT, STRICT
          LIABILITY, BREACH OF WARRANTIES, FAILURE OF ESSENTIAL PURPOSE OR OTHERWISE AND EVEN IF ADVISED OF THE
          POSSIBILITY OF SUCH DAMAGES. FURTHER, OTHER THAN FOR BREACH OF INTELLECTUAL PROPERTY RIGHTS, A LIABILITY FOR
          ANY AND ALL CLAIMS ARISING UNDER OR RELATED TO THIS AGREEMENT SHALL NOT EXCEED THE TOTAL OF SUMS PAID (OR
          OWING BUT UNPAID) UNDER THE PROPOSAL TO WHICH THE CLAIM RELATES.
        </div>
      </div>

      <div>
        <div className='agreement-section-header'>7. Indemnification.</div>
        <div>
          Each party agrees to defend and indemnify the other party from all claims, losses, expenses, fees (including
          reasonable legal fees and expenses), costs, and judgments, brought from an unrelated third party that may be
          asserted against the other party to this agreement which arise directly as a result of : (i) any violation of
          applicable laws or regulations by the indemnifying party regarding data protection; or (ii) the gross
          negligence, false representation, or other willful misconduct of such party and (iii) additionally Company
          agrees to indemnify Customer against any claims that the use or possession of the System by the Customer
          infringes or violates the copyright, patent, trade secret or other proprietary rights of any third party. In
          the event of such a claim or if Company believes such a claim of infringement may be asserted, Company may, at
          its option (I) obtain a license from the applicable third party; (II) modify the item at issue so as to be
          non-infringing; or (III) terminate the Proposal applicable to such item and refund to Customer any pre-paid
          fees applicable to such terminated item. In the event of any claim or action relating to any matter for which
          a party has agreed to provide indemnification under this Agreement, the indemnified party shall promptly
          provide notice of such claim or action to the indemnifying Party and the indemnified party shall provide the
          indemnifying party, at no out-of-pocket expense to the indemnified party,reasonable assistance in the defense
          of such action. The indemnifying party shall control such litigation and at its sole option, negotiate a
          settlement or compromise thereof. Any counsel retained by the indemnified party to consult or participate in
          the defense will be retained by the indemnified party solely at its own expense, which expense is not included
          in the indemnity.
        </div>
      </div>

      <div>
        <div className='agreement-section-header'>8. Term.</div>
        <div className='agreement-section-content'>
          <div>
            <b>8.1</b> The term of this Agreement shall be 12 months from Checkout Date and will continue until
            terminated pursuant to the terms hereof. Thereafter, this Agreement shall automatically renew for additional
            terms of 12 months each so long as any Proposal under this Agreement remains in effect (and this Agreement
            has not been previously terminated). Customer shall be provided notice of impending renewal thirty (30) days
            prior to effective date of renewal term.
          </div>
          <div>
            <b>8.2</b> Either party may terminate this Agreement or any Proposal or automatic renewal upon thirty (30)
            days prior notice to the other party. Should Customer wish to cancel automatic renewal or initiate
            termination of the Agreement, Customer should contact WireVault customer support at either{' '}
            <a className='agreement-link' href='mailto:support@wirevault.co'>
              support@wirevault.co
            </a>{' '}
            or by phone at{' '}
            <a className='agreement-link' href='tel:+18886686221'>
              +1 (888) 668-6221
            </a>
            .
          </div>
          <div>
            <b>8.3</b> Either party may terminate this Agreement or any Proposal: (i) if the other party is in material
            breach or default of any obligation hereunder, which breach or default is not cured within thirty (30) days
            of written notice from the other party; (ii) if the other party becomes insolvent, upon five (5 days written
            notice from the other party; or (iii) if the other party files as a debtor under any bankruptcy, insolvency
            or liquidation law, whether domestic or foreign or such a filing is made against the such party and such
            involuntary filing is not dismissed within sixty (60) days of commencement thereof.
          </div>
          <div>
            <b>8.4</b> The Company offers both monthly and annual billing options. So that we can manage your services
            effectively and to ensure seamless continuity of those services, this Agreement shall renew automatically
            for successive periods equal to the current term unless terminated in accordance with Section 8.2. Customers
            will receive advance notice of any automatic renewal as provided in Section 8.1.
          </div>
          <div>
            <b>8.5</b> In the event a Customer’s payment is declined, the Company will provide a three (3) calendar day
            grace period to resolve the billing issue. If the issue is not resolved within this timeframe, certain
            features of the WireVault System, including but not limited to the ability to access or transmit payment or
            deposit instructions, may be temporarily suspended until full payment is received. Customer subscriptions
            include a defined monthly or annual allotment of “payment and deposit instructions” as specified in the
            selected billing plan. Upon reaching this limit, the Customer may elect to purchase additional usage
            ("Overage") or upgrade to a higher-tier plan. If the Customer does not elect either option, the Company
            reserves the right to restrict visibility to any further payment or depositor assigning. The above
            restrictions do not apply to Customer’s ability to access their personal data as provided by applicable law.
          </div>
        </div>
      </div>

      <div>
        <div className='agreement-section-header'>9. Miscellaneous Terms.</div>
        <div>
          The Parties agree that the Company shall be permitted to include Customer as a client in its marketing
          efforts. This agreement and the Proposal constitute the entire agreement between Company and Customer
          regarding its subject matter, and is exclusively governed by the laws of the State of Delaware.
        </div>
      </div>
    </div>
`;
